module.exports = __webpack_public_path__ + "static/media/credit.c88d93b4.png";